import React from 'react';
import { Control, Controller } from 'react-hook-form';
import { 
  Box, 
  TextField, 
  Typography, 
  GridLegacy as Grid,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
} from '@mui/material';

interface ShippingAddressSectionProps {
  control: Control<Gift.Crud>;
  dictionary: any;
}
const AddressFields: React.FC<any> = ({ control, dictionary }) => {
  return (
    <Box mt={2}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Controller
            name="shippingStreet"
            control={control}
            rules={{ required: dictionary.forms.validations.required }}
            render={({ field, fieldState }) => (
              <TextField
                {...field}
                label="Street Address"
                error={!!fieldState.error}
                helperText={fieldState.error?.message}
                fullWidth
                slotProps={{
                  input: {
                    sx: {
                      'fieldset': {
                        borderRadius: '10px',
                      },
                    },
                  },
                }}
              />
            )}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <Controller
            name="shippingCity"
            control={control}
            rules={{ required: dictionary.forms.validations.required }}
            render={({ field, fieldState }) => (
              <TextField
                {...field}
                label="City"
                error={!!fieldState.error}
                helperText={fieldState.error?.message}
                fullWidth
                slotProps={{
                  input: {
                    sx: {
                      'fieldset': {
                        borderRadius: '10px',
                      },
                    },
                  },
                }}
              />
            )}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <Controller
            name="shippingState"
            control={control}
            render={({ field, fieldState }) => (
              <TextField
                {...field}
                label="State/Province"
                error={!!fieldState.error}
                helperText={fieldState.error?.message}
                fullWidth
                slotProps={{
                  input: {
                    sx: {
                      'fieldset': {
                        borderRadius: '10px',
                      },
                    },
                  },
                }}
              />
            )}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <Controller
            name="shippingPostCode"
            control={control}
            rules={{ required: dictionary.forms.validations.required }}
            render={({ field, fieldState }) => (
              <TextField
                {...field}
                label="Postal Code"
                error={!!fieldState.error}
                helperText={fieldState.error?.message}
                fullWidth
                slotProps={{
                  input: {
                    sx: {
                      'fieldset': {
                        borderRadius: '10px',
                      },
                    },
                  },
                }}
              />
            )}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <Controller
            name="shippingCountry"
            control={control}
            rules={{ required: dictionary.forms.validations.required }}
            render={({ field, fieldState }) => (
              <TextField
                {...field}
                label="Country"
                error={!!fieldState.error}
                helperText={fieldState.error?.message}
                fullWidth
                slotProps={{
                  input: {
                    sx: {
                      'fieldset': {
                        borderRadius: '10px',
                      },
                    },
                  },
                }}
              />
            )}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

const ShippingAddressSection: React.FC<ShippingAddressSectionProps> = ({ control, dictionary }) => {
  return (
    <Box sx={{ '& > *': { mb: 2 } }}>
      <Typography variant="subtitle1" sx={{ fontWeight: 'medium', color: 'text.secondary' }}>
        Shipping Choice *
      </Typography>

      <Controller
        name="shippingChoice"
        control={control}
        defaultValue="recipient"
        rules={{ required: dictionary.forms.validations.required }}
        render={({ field }) => (
          <FormControl component="fieldset" sx={{ width: '100%' }}>
            <RadioGroup
              {...field}
              sx={{ '& > *': { mb: 1.5 } }}
            >
              <Box 
                sx={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  p: 1.5, 
                  border: '1px solid', 
                  borderColor: 'divider', 
                  borderRadius: 2,
                  '&:hover': { bgcolor: 'action.hover' },
                }}
              >
                <FormControlLabel 
                  value="recipient" 
                  control={<Radio id="ship-recipient" />} 
                  label={
                    <Box sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }} >
                      Ship directly to recipient
                    </Box>
                  }
                  sx={{ m: 0, width: '100%' }}
                />
              </Box>

              <Box 
                sx={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  p: 1.5, 
                  border: '1px solid', 
                  borderColor: 'divider', 
                  borderRadius: 2,
                  '&:hover': { bgcolor: 'action.hover' },
                }}
              >
                <FormControlLabel 
                  value="gifter" 
                  control={<Radio id="ship-gifter" />} 
                  label={
                    <Box sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                      Ship to me first
                    </Box>
                  }
                  sx={{ m: 0, width: '100%' }}
                />
              </Box>
            </RadioGroup>
          </FormControl>
        )}
      />

      {/* Address Fields Section */}
      <Controller
        name="shippingChoice"
        control={control}
        render={({ field }) => (
          <Box mt={2}>
            <Typography variant="subtitle1" gutterBottom>
              {field.value === 'gifter' ? 'Your Address' : 'Recipient Address'}
            </Typography>
            <AddressFields control={control} dictionary={dictionary} />
          </Box>
        )}
      />
    </Box>
  );
};

export default ShippingAddressSection;
